import { render, staticRenderFns } from "./WikiLearnMoreLink.vue?vue&type=template&id=3c206073&"
import script from "./WikiLearnMoreLink.vue?vue&type=script&lang=js&"
export * from "./WikiLearnMoreLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports